import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  dialogPaper: {
    overflow: 'visible',
    margin: 'auto',
  },
  dialogContent: {
    overflow: 'visible',
  },
  formLabel: {
    width: '100%',
    marginBottom: '4px',
    fontSize: '16px',
    fontWeight: foundations.typography.fontWeight.medium,
  },
  modalDescription: {
    marginBottom: '24px',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  radioButton: {
    width: '100%',
    alignItems: 'flex-start',
    '& .MuiFormControlLabel-label': { width: '100%' },
    '& input[type="radio"]': {
      display: 'none',
    },
  },
  radioDescription: {
    paddingTop: '8px',
    width: '100%',
  },
  errorMsg: {
    marginTop: '8px',
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px',
  },
  locationFormControl: {
    width: '100%',
  }
});
